import {
  Box,
  Button,
  Chip,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import AffiliatedIcon from "../../../Assets/Img/affilicated-icon.svg";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { InfluencerStatus } from "../../../../utils/constants";

export const BrandList = ({
  state,
  data,
  containerSx = {},
  currentPage,
  onPageChange,
  total,
}) => {
  return (
    <Box
      sx={{
        ...containerSx,
        display: "flex",
        gap: "1rem",
        flexDirection: "column",
      }}
    >
      <TableContainer
        sx={{
          marginTop: "8px",
          height: "100%",
          zIndex: 0,

          ...containerSx,
        }}
      >
        <Table
          sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  background: "#F5F2E7",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                }}
              >
                Brands
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                Affiliated with
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                E-mails
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                Phone
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                Registered Date
              </TableCell>
              {state === "approved" ? (
                <TableCell sx={{ background: "#F5F2E7" }} align="center">
                  Status
                </TableCell>
              ) : (
                <></>
              )}
              <TableCell
                sx={{
                  background: "#F5F2E7",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                align="center"
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              marginTop: "8px",
            }}
          >
            {data.map((d) => (
              <TableRow
                key={d.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  height: "80px",
                }}
              >
                <TableCell>
                  <Box display={"flex"} alignItems={"center"} gap={1}>
                    <img
                      src="https://s3-alpha-sig.figma.com/img/545b/4bc5/949601d57079ee914eb831f92db4e3f8?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=AvSHyGjFHD4sOPVEzRQjniEhhi9S9oQOWzwxpoDPdA77ZcZ~yXqURpHp3uMud9y7o~KzV6DY7kXFwvjtn5j1JZrn40t-CX-IIivNzJ40NfDtDpLdvGTPJdYa95ThMrUPjfLNrNyn1dIO5ujBDpwo9ciu7DZS88Q50aSuY746zPnt-3JW5C6386QzSP5FmeIu0AAgDtaH0hyDUM-7aO4iWDTd0oF42OGGSvY7uIt4Lbh~~3Y5ygCbD6Fl~d3K4g65COA56umeuV4NpUS4sU8L40eGAkIYMEnXS2dg7qkny0rcCDx5wK9r4AuC5p9qfQ3ZMYMkw6y-68vtgwn1qOu6WQ__"
                      alt=""
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "25px",
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "#3D3D3D",
                        }}
                      >
                        {d.name}
                      </Typography>
                      <Typography sx={{ fontSize: "12px", color: "#9D9D9D" }}>
                        {d.username}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <img
                    src={AffiliatedIcon}
                    alt=""
                    style={{
                      width: "24px",
                      height: "24px",
                    }}
                  />
                </TableCell>
                <TableCell align="center">{d.email}</TableCell>
                <TableCell align="center">{d.phone}</TableCell>
                <TableCell align="center">{d.registeredDate}</TableCell>
                {state === "approved" ? (
                  <TableCell align="center">
                    <Chip
                      variant="filled"
                      label={InfluencerStatus[d.status].label}
                      sx={{
                        backgroundColor: InfluencerStatus[d.status].background,
                        color: InfluencerStatus[d.status].color,
                      }}
                    />
                  </TableCell>
                ) : (
                  <></>
                )}
                <TableCell align="center">
                  <Box
                    display={"flex"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    {state === "approved" ? (
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#CD0B0B",
                          fontSize: "14px",
                          borderColor: "#CD0B0B !important",
                        }}
                      >
                        Delete
                      </Button>
                    ) : (
                      <></>
                    )}
                    {state === "pending" ? (
                      <Button
                        variant="text"
                        sx={{ color: "#CD0B0B", fontSize: "14px" }}
                      >
                        Decline
                      </Button>
                    ) : (
                      <></>
                    )}
                    {state === "pending" || state === "declined" ? (
                      <Button
                        variant="outlined"
                        sx={{ color: "#6b8e76", fontSize: "14px" }}
                      >
                        Approve
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <Pagination
          count={total}
          showFirstButton
          showLastButton
          page={currentPage}
          onChange={(_, page) => {
            onPageChange(page);
          }}
          sx={{
            "& button": {
              border: "none !important",
            },
          }}
          shape="circular"
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: MdKeyboardDoubleArrowLeft,
                last: MdKeyboardDoubleArrowRight,
              }}
              {...item}
            />
          )}
        />
      </Box>
    </Box>
  );
};
